export default "__VITE_ASSET__5F$H918W__"